import { get, post } from "../https";

const api = "/xywapi";

// 申领纸质证书
export async function certApply(data) {
  return await post(`${api}${data.url}`, data);
}

// 取消 纸质证书申领
export async function certCancel(data) {
  return await post(`${api}/certOrder/cancelCertOrder`, data);
}

// 申请退款 纸质证书申领
export async function certCancelRefund(data) {
  return await post(`${api}/certOrder/cancelCertRefundOrder/${data.id}`, data);
}



// 申领纸质证书 详情
export async function certDetail(data) {
  return await get(`${api}/certOrder/paperCertInfo/${data.id}`, data);
}


// 删除
export async function certDelete(data) {
  return await post(`${api}/certOrder/del/${data.id}`, data);
}

// 确认收货
export async function certReceive(data) {
  return await post(`${api}/certOrder/confirmReceipt/${data.id}`, data);
}

// 某作品申领纸质证书 列表
export async function certList(data) {
  return await post(`${api}/certOrder/getCertOrdersPageList`, data);
}


// 支付 纸质证书申领
export async function certPay(data) {
  return await post(`${api}/certOrder/payCertOrder/${data.id}?openid=${data.openid}`, data);
}




